import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-new-add-project-scenario-manufacturing',
  templateUrl: './new-add-project-scenario-manufacturing.component.html',
  styleUrls: ['./new-add-project-scenario-manufacturing.component.scss'],
})
export class NewAddProjectScenarioManufacturingComponent {
  distanceBlack = './assets/icons/BasedOnDistance.png';
  distanceWhite = './assets/icons/BasedOnDistanceWhite.png';
  locationBlack = './assets/icons/BasedOnLocations.png';
  loactionWhite = './assets/icons/BasedOnLocationsWhite.png';
  customBlack = './assets/icons/CustomScenarios.png';
  customWhite = './assets/icons/CustomScenariosWhite.png';

  scenarioAddEditForm!: FormGroup;

  statusItems = [{ name: 'Draft' }, { name: 'Complete' }];
  packageItems = [{ name: 'PIQET PACKAGE Test' }];

  commonInputSearch() {}

  constructor(private modal: CustomModalService, private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.scenarioAddEditForm = this.formBuilder.group({
      projectName: [null, Validators.required],
      projectNameForReport: [null, Validators.required],
      share: [null],
      status: [null],
      description: [null],
    });
  }

  onClose() {
    this.modal.close();
  }
}
